/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
//import Footer from "components/Footer/Footer.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2021/05/skitch-not-working-on-mac/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2021/05/skitch-not-working-on-mac/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2021/05/skitch-not-working-on-mac/SectionSimilarStories.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






export const metadata = {
  title: "Skitch Not Working On Mac? (May 2021) - Why is Skitch Not Working on Mac? - Tribalism",
  date: "2021-05-13",
  summary: "We are an Australian Digital Marketing Agency based in Melbourne. We can help you with all types of applications such as Skitch! Save yourself a couple of hours from reading irrelevant articles on this delivered by google and get your answers here.",
  image: "/img/posts/2021-05-13-skitch/skitch-not-working-on-mac.webp",
  url: "https://www.tribalism.com.au/blog-post/2021/05/skitch-not-working-on-mac",
  author: "Scott Sunderland",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Why is Skitch Not Working on Mac? - Tribalism"
        image="/img/posts/2021-05-13-skitch/skitch-not-working-on-mac.webp"
        url="https://www.tribalism.com.au/blog-post/2021/05/skitch-not-working-on-mac"
        type="article"
        description="We are an Australian Digital Marketing Agency based in Melbourne. We can help you with all types of applications such as Skitch !"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2021-05-13-skitch/skitch-not-working-on-mac.webp" filter="dark">
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>
              Skitch Not Working On Mac? (May 2021)
              </h1>
              <h4 className={classes.subtitle}>
                Save yourself a couple of hours from reading irrelevant articles on this delivered by google and get your answers here
              </h4>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />
        </div>
      </div>
      <SectionSimilarStories />


      <Footer
       
      />
    </div>
  );
}
